import { render, staticRenderFns } from "./BanniereAccueil.vue?vue&type=template&id=50d8d3e2&scoped=true&"
import script from "./BanniereAccueil.vue?vue&type=script&lang=js&"
export * from "./BanniereAccueil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d8d3e2",
  null
  
)

export default component.exports